module.exports = "/assets/site/images/icon_date.png?695fc88f8ddbe3e58c2c3c509c0d96cf";